"use strict";
exports.__esModule = true;
exports.WalletErrorCode = void 0;
var WalletErrorCode;
(function (WalletErrorCode) {
    WalletErrorCode["W_UNCAUGHT_EXCEPTION"] = "W30000";
    WalletErrorCode["W_CARD_LINKAGE_THRESHOLD"] = "W30001";
    WalletErrorCode["W_BLOCK_CAPITAL_ONE"] = "W30002";
    WalletErrorCode["W_ADD_FUNDS_INVALID_AMOUNT"] = "W30004";
    WalletErrorCode["W_ADD_FUNDS_TOS"] = "W30005";
    WalletErrorCode["W_ADD_FUNDS_MAX_ATTEMPTS_EXCEEDED"] = "W30006";
    WalletErrorCode["W_ADD_FUNDS_MAX_BALANCE_EXCEEDED"] = "W30007";
    WalletErrorCode["W_ADD_FUNDS_DEBIT_CARD_REQUIRED"] = "W30008";
    WalletErrorCode["W_ADD_FUNDS_INACTIVE_ACCOUNT"] = "W30009";
    WalletErrorCode["W_WITHDRAW_FUNDS_INVALID_AMOUNT"] = "W30010";
    WalletErrorCode["W_WITHDRAW_DEBIT_CARD_REQUIRED"] = "W30011";
    WalletErrorCode["W_WITHDRAW_PAYMENT_METHOD_ADDED_WITHIN_24_HOURS"] = "W30012";
    WalletErrorCode["W_WITHDRAW_FUNDS_MAX_COUNTED_EXCEEDED"] = "W30013";
    WalletErrorCode["W_WITHDRAW_FUNDS_RENT_PAYMENT_PROCESSING"] = "W30014";
    WalletErrorCode["W_WITHDRAW_FUNDS_WITHDRAWAL_IN_PROGRESS"] = "W30015";
})(WalletErrorCode = exports.WalletErrorCode || (exports.WalletErrorCode = {}));
